module.exports = __webpack_public_path__ + "static/media/appAdvertBtmLogo_white.ce9a7163.svg";